import { useStoreSelector } from 'hooks/store'
import ItsmeView from 'features/registration/steps/itsme-view/ItsmeView'
import { type OverviewStepProps } from '../types'
import Overview from './Overview'
import { IDENTIFICATION_METHODS } from '@boltenergy-be/shared'
import { useRouter } from 'next/router'
import { INTERNAL_REGISTRATION_URL_PARAMS } from 'constants/customer-flow'

const OverviewDataWrapper = (props: OverviewStepProps) => {
  // Redux store
  const { itsme } = useStoreSelector((store) => store.customer)
  const { identificationMethod, emailConfirmationFlow, confirmationFromPortalRegistration } = useStoreSelector((store) => store.marketing)

  // Next router
  const { query } = useRouter()

  // Constants
  const isNotToBeConfirmed = query[INTERNAL_REGISTRATION_URL_PARAMS.IS_NOT_TO_BE_CONFIRMED] === 'true'
  const isClosedWon = query[INTERNAL_REGISTRATION_URL_PARAMS.IS_CLOSED_WON] === 'true'
  const canConfirm = !isNotToBeConfirmed && !isClosedWon
  const hasToIdentifyBeforeConfirming =
    canConfirm &&
    !itsme?.prefilled &&
    identificationMethod === IDENTIFICATION_METHODS.itsme &&
    emailConfirmationFlow &&
    !confirmationFromPortalRegistration

  return hasToIdentifyBeforeConfirming ? <ItsmeView isConfirmation /> : <Overview {...props} />
}

export default OverviewDataWrapper
